import { createAsyncThunk } from "@reduxjs/toolkit";
import { iGenericResponse } from "./Types";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { orderReportDataList } from "@/services/api/cresivoxServer";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { REDUCER_NAME } from "./Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// Define allowed query params
export interface iOrderReportQuery {
  status?: string;
  year?: string;
  startDate?: string;
  endDate?: string;
}

export const getOrderReportData = createAsyncThunk<
  iGenericResponse<any>, // Replace `any` with your `iOrderReportData` type
  iOrderReportQuery | void,
  { rejectValue: { message: string } }
>(
  curriedGetThunkName("getOrderReportData"),
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await orderReportDataList.getOrderReportData(queryParams);

      if (!response) {
        return rejectWithValue({ message: "No response received" });
      }

      const { httpStatusCode, data, message } = response;

      if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
        return {
          httpStatusCode,
          data: data.data,
          message,
        };
      }

      return rejectWithValue({ message: "Order report not found in response" });
    } catch (error) {
      console.error("🚀 ~ getOrderReportData error:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);
